<template>
    <div class="device-state" :style="{ 'borderColor': typeColor }">
        <div class="device-state__content">
            <div class="device-state__icon">
                <svg v-if="element === 'water'" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 3C8.3375 8.6875 5 13.6 5 17.75C5 23.975 9.75 28 15 28C20.25 28 25 23.975 25 17.75C25 13.6 21.6625 8.6875 15 3ZM15 25.5C10.8125 25.5 7.5 22.2875 7.5 17.75C7.5 14.825 9.9375 10.95 15 6.325C20.0625 10.95 22.5 14.8125 22.5 17.75C22.5 22.2875 19.1875 25.5 15 25.5Z" :fill="typeColor"/>
                </svg>
                <svg v-else-if="element === 'balancer'" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24.2902 16.725C24.3402 16.325 24.3777 15.925 24.3777 15.5C24.3777 15.075 24.3402 14.675 24.2902 14.275L26.9277 12.2125C27.1652 12.025 27.2277 11.6875 27.0777 11.4125L24.5777 7.0875C24.4652 6.8875 24.2527 6.775 24.0277 6.775C23.9527 6.775 23.8777 6.7875 23.8152 6.8125L20.7027 8.0625C20.0527 7.5625 19.3527 7.15 18.5902 6.8375L18.1152 3.525C18.0777 3.225 17.8152 3 17.5027 3H12.5027C12.1902 3 11.9277 3.225 11.8902 3.525L11.4152 6.8375C10.6527 7.15 9.95273 7.575 9.30273 8.0625L6.19023 6.8125C6.11523 6.7875 6.04023 6.775 5.96523 6.775C5.75273 6.775 5.54023 6.8875 5.42773 7.0875L2.92773 11.4125C2.76523 11.6875 2.84023 12.025 3.07773 12.2125L5.71523 14.275C5.66523 14.675 5.62773 15.0875 5.62773 15.5C5.62773 15.9125 5.66523 16.325 5.71523 16.725L3.07773 18.7875C2.84023 18.975 2.77773 19.3125 2.92773 19.5875L5.42773 23.9125C5.54023 24.1125 5.75273 24.225 5.97773 24.225C6.05273 24.225 6.12773 24.2125 6.19023 24.1875L9.30273 22.9375C9.95273 23.4375 10.6527 23.85 11.4152 24.1625L11.8902 27.475C11.9277 27.775 12.1902 28 12.5027 28H17.5027C17.8152 28 18.0777 27.775 18.1152 27.475L18.5902 24.1625C19.3527 23.85 20.0527 23.425 20.7027 22.9375L23.8152 24.1875C23.8902 24.2125 23.9652 24.225 24.0402 24.225C24.2527 24.225 24.4652 24.1125 24.5777 23.9125L27.0777 19.5875C27.2277 19.3125 27.1652 18.975 26.9277 18.7875L24.2902 16.725ZM21.8152 14.5875C21.8652 14.975 21.8777 15.2375 21.8777 15.5C21.8777 15.7625 21.8527 16.0375 21.8152 16.4125L21.6402 17.825L22.7527 18.7L24.1027 19.75L23.2277 21.2625L21.6402 20.625L20.3402 20.1L19.2152 20.95C18.6777 21.35 18.1652 21.65 17.6527 21.8625L16.3277 22.4L16.1277 23.8125L15.8777 25.5H14.1277L13.6902 22.4L12.3652 21.8625C11.8277 21.6375 11.3277 21.35 10.8277 20.975L9.69023 20.1L8.36523 20.6375L6.77773 21.275L5.90273 19.7625L7.25273 18.7125L8.36523 17.8375L8.19023 16.425C8.15273 16.0375 8.12773 15.75 8.12773 15.5C8.12773 15.25 8.15273 14.9625 8.19023 14.5875L8.36523 13.175L7.25273 12.3L5.90273 11.25L6.77773 9.7375L8.36523 10.375L9.66523 10.9L10.7902 10.05C11.3277 9.65 11.8402 9.35 12.3527 9.1375L13.6777 8.6L13.8777 7.1875L14.1277 5.5H15.8652L16.3027 8.6L17.6277 9.1375C18.1652 9.3625 18.6652 9.65 19.1652 10.025L20.3027 10.9L21.6277 10.3625L23.2152 9.725L24.0902 11.2375L22.7527 12.3L21.6402 13.175L21.8152 14.5875ZM15.0027 10.5C12.2402 10.5 10.0027 12.7375 10.0027 15.5C10.0027 18.2625 12.2402 20.5 15.0027 20.5C17.7652 20.5 20.0027 18.2625 20.0027 15.5C20.0027 12.7375 17.7652 10.5 15.0027 10.5ZM15.0027 18C13.6277 18 12.5027 16.875 12.5027 15.5C12.5027 14.125 13.6277 13 15.0027 13C16.3777 13 17.5027 14.125 17.5027 15.5C17.5027 16.875 16.3777 18 15.0027 18Z" :fill="typeColor"/>
                </svg>
                <svg v-else-if="element === 'security'" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 1.75L3.75 6.75V14.25C3.75 21.1875 8.55 27.675 15 29.25C21.45 27.675 26.25 21.1875 26.25 14.25V6.75L15 1.75ZM23.75 14.25C23.75 19.9 20.025 25.1125 15 26.6625C9.975 25.1125 6.25 19.9 6.25 14.25V8.375L15 4.4875L23.75 8.375V14.25ZM9.2625 14.9875L7.5 16.75L12.5 21.75L22.5 11.75L20.7375 9.975L12.5 18.2125L9.2625 14.9875Z" :fill="typeColor"/>
                </svg>
                <svg v-else-if="element === 'elevator'" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.75 6.75V24.25H6.25V6.75H23.75ZM23.75 4.25H6.25C4.875 4.25 3.75 5.375 3.75 6.75V24.25C3.75 25.625 4.875 26.75 6.25 26.75H23.75C25.125 26.75 26.25 25.625 26.25 24.25V6.75C26.25 5.375 25.125 4.25 23.75 4.25ZM12.5 23V18H13.75V14.875C13.75 13.5 12.625 12.375 11.25 12.375H10C8.625 12.375 7.5 13.5 7.5 14.875V18H8.75V23H12.5ZM10.625 11.125C11.4875 11.125 12.1875 10.425 12.1875 9.5625C12.1875 8.7 11.4875 8 10.625 8C9.7625 8 9.0625 8.7 9.0625 9.5625C9.0625 10.425 9.7625 11.125 10.625 11.125ZM22.5 14.25L19.375 9.25L16.25 14.25H22.5ZM16.25 16.75L19.375 21.75L22.5 16.75H16.25Z" :fill="typeColor"/>
                </svg>
                <svg v-else-if="element === 'electricity'" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.7443 26.75H12.4943L13.7443 18H9.36935C8.26935 18 8.95685 17.0625 8.98185 17.025C10.5943 14.175 13.0193 9.925 16.2568 4.25H17.5068L16.2568 13H20.6444C21.1444 13 21.4193 13.2375 21.1443 13.825C16.2068 22.4375 13.7443 26.75 13.7443 26.75Z" :fill="typeColor"/>
                </svg>
            </div>
            <div class="device-state__info">
                <div class="device-state__details">
                    <div class="device-state__element">
                        {{ elementName }}
                    </div>
                    <div class="device-state__device can-overflow">
                        {{ deviceName }}
                    </div>
                    <div class="device-state__state">
                        <app-base-state
                            :id="elementState.id"
                            :name="elementState.name"
                            :background="elementState.background"
                        />
                    </div>
                </div>
                <div class="device-state__control-btn">
                    <button type="button">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.8219 12.6437L4.92815 13.75L11.1781 7.5L4.92815 1.25L3.8219 2.35625L8.96565 7.5L3.8219 12.6437Z" fill="#848484"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { dashboardCardStates } from "../../../constants/states";

    export default {
        name: "AppDeviceStateCard",

        props: {
            id: {
                type: String,
                required: true
            },
            building: {
                type: String,
                required: true
            },
            element: {
                type: String,
                required: true
            },
            device: {
                type: String,
                required: true
            },
            type: {
                type: Number,
                required: true
            },
            state: {
                type: Number,
                required: true
            }
        },

        computed: {
            typeColor() {
                return this.type === 0
                    ? 'var(--app-base-primary)'
                    : this.type === 1
                    ? 'var(--system-orange)'
                    : 'var(--system-red)'
            },

            elementState() {
                return dashboardCardStates.find((state) => state.id === this.state);
            },

            elementName() {
                return this.$t(`dashboard.elements.${this.element}`);
            },

            deviceName() {
                return `${this.building}, ${this.device}`;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .device-state {
        border: 1px solid;
        border-radius: 13px;
        background: var(--system-white);

        &__icon {
            padding: 20px;
            border-radius: 13px;
            background: var(--app-table-background);
            width: 70px;
            height: 70px;
            margin-right: 15px;
        }

        &__content {
            padding: 15px;
            display: flex;
        }

        &__info {
            flex-grow: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        &__element {
            font-size: 18px;
            font-weight: 600;
        }

        &__device {
            font-size: 14px;

            @media screen and (max-width: 1600px) {
                max-width: 220px;
            }
        }

        &__element, &__device {
            margin-bottom: 5px;
        }

        &__control-btn {
           width: 15px;
           height: 15px;
        }
    }
</style>